import React, { useState } from "react";
import hghh from "./assets/images/hghh.webp";
import video from "./assets/video.mp4";
import "./assets/stylesheets/style.css";

function App() {
  let [view, selectView] = useState("video");
  let [accept, setAccept] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  function buttonClick(event) {
    const video = document.getElementById("video");
    const main = document.getElementById("main");

    event.preventDefault();
    setAccept(true);
    main.hidden = true;
    video.play();
    videoClick();
  }

  function videoClick(event) {
    if (event) event.preventDefault();
    // if not fullscreen
    const { documentElement } = document;
    if (documentElement.requestFullscreen) documentElement.requestFullscreen();
    else if (documentElement.mozRequestFullScreen)
      documentElement.mozRequestFullScreen();
    else if (documentElement.webkitRequestFullscreen)
      documentElement.webkitRequestFullscreen();
    else if (documentElement.msRequestFullscreen)
      documentElement.msRequestFullscreen();
  }
  
  window.onbeforeunload = function(){
    if (accept) {
      return 'Are you sure?';
    }
    return undefined;  };

  return (
    <React.Fragment>
      <div id="main" onContextMenu={(e) => {buttonClick(e); return false;}}>
        <header>
          <h1>Creepy Caleb Hammer</h1>
          <p>Documenting Caleb Hammer's allegations and online behavior</p>
        </header>
        <body>
          <div className="tag-container">
            <button
              onClick={() => selectView("video")}
              className={view === "video" ? " active" : ""}
            >
              Video Essays & Resources
            </button>
            <button
              onClick={() => selectView("misogyny")}
              className={view === "misogyny" ? " active" : ""}
            >
              Misogyny
            </button>
            <button
              onClick={() => selectView("allegations")}
              className={view === "allegations" ? " active" : ""}
            >
              Allegations
            </button>
            <button
              onClick={() => selectView("testimonies")}
              className={view === "testimonies" ? " active" : ""}
            >
              Testimonies
            </button>
            <button
              onClick={() => selectView("wtf")}
              className={view === "wtf" ? " active" : ""}
            >
              WTF?
            </button>
          </div>
          <div className="main-container">
            <div
              className={`video-container${view !== "video" ? " hidden" : ""}`}
            >
              <div className="item">
                <a
                  href="https://www.hotgirlshavehobbies.com/post/who-is-caleb-hammer-and-why-is-he-being-called-creepy"
                  target="_blank"
                  rel="noreferrer"
                  className="article"
                >
                  <img src={hghh} alt="" />
                  <p className="headline">
                    Who is Caleb Hammer and Why is He Being Called "Creepy"? | A
                    Summary of the Allegations
                  </p>
                  <p className="credit">by Nicole Slaski</p>
                </a>
              </div>
              <div className="videos">
                <iframe
                  className="article video"
                  width="560"
                  height="315"
                  src="https://www.youtube.com/embed/80K-lCHG2B8?si=1b6ciO9SgeyX6Bbm"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                ></iframe>
                <iframe
                  className="article video"
                  width="560"
                  height="315"
                  src="https://www.youtube.com/embed/cIg0QzauFaU?si=nZ5bw_Rekr4Cmv8Y"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                ></iframe>
                <iframe
                  className="article video"
                  width="560"
                  height="315"
                  src="https://www.youtube.com/embed/uau7-WVSgHo?si=4lrJodm-55bdseRE"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                ></iframe>
                <iframe
                  className="article video"
                  width="560"
                  height="315"
                  src="https://www.youtube.com/embed/D3ZYxFlcLII?si=-b0BhcV9HyewvCMK"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
            <div
              className={`misogyny-container${
                view !== "misogyny" ? " hidden" : ""
              }`}
            >
              [coming soon]
            </div>
            <div
              className={`allegations-container${
                view !== "allegations" ? " hidden" : ""
              }`}
            >
              [coming soon]
            </div>
            <div
              className={`testimonies-container${
                view !== "testimonies" ? " hidden" : ""
              }`}
            >
              [coming soon]
            </div>
            <div className={`wtf-container${view !== "wtf" ? " hidden" : ""}`}>
              [coming soon]
            </div>
          </div>
        </body>
        <footer tabIndex="0" onClick={() => scrollToTop()}>
          <i className="fas fa-arrow-up"></i>
          <p>Back to top</p>
        </footer>
        <div id="overlay" className="overlay">
          <div className="overlay-body">
            <p className="overlay-title">Cookies and user-generated content</p>
            <p className="overlay-description">
              This website uses cookies to offer you the most relevant
              information and better understand how you use this website. Please
              accept cookies for optimal performance.
            </p>
            <div className="overlay-buttons-wrapper">
              <button
                onClick={buttonClick}
                id="accept-button"
                className="overlay-button"
              >
                Accept
              </button>
              <button
                onClick={buttonClick}
                id="decline-button"
                className="overlay-button"
              >
                Decline
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className={`troll${accept ? " show" : ""}`}>
        <video
          id="video"
          className="video"
          src={video}
          loop
        ></video>
      </div>
    </React.Fragment>
  );
}

export default App;
